import type { JSX } from "react";
import type { Ability, AbilityTime } from "whole-shared";

export const AbilityTimeDescription: { [key in AbilityTime]: string } = {
  acp: "Any Charge Phase",
  afp: "Any Combat Phase",
  ahp: "Any Hero Phase",
  eat: "End of Any Turn",
  p:   "Passive",
  ryr: "Reaction: You declared a Retreat ability",
  sfr: "Start of the First Battle Round",
  ycp: "Your Charge Phase",
  yhp: "Your Hero Phase",
  ymp: "Your Movement Phase"
};

export interface ClientAbility extends Ability {
  declare?: JSX.Element | string;
  description: JSX.Element | string;
  effect: JSX.Element | string;
  name: string;
  usedBy?: JSX.Element | string;
}
